<template>
    <div style="background-color:black;black; height:100vh;">
        <!-- 顶部 标题栏 -->
        <van-nav-bar left-arrow style="background-color:#393a3f;position:relative;" @click-left="handelLeftMenuFunc()" @click-right="showSerialPannel=!showSerialPannel">
            <template #left>
                <van-icon name="arrow-left" size="18" color='white' />
            </template>
            <template #title>
                <span style="color: white;">云胶片</span>
            </template>
        </van-nav-bar>
        <div>
            <img v-for="(item,index) in filmList" class="double-border" :src="item" :key="index" @click='handerImagePreview(index)' />
        </div>
    </div>
</template>
<script>
    /* eslint-disable no-unused-vars */
    /* eslint-disable no-debugger */
    import { ImagePreview } from 'vant'
    import { GetPatientReportImageInfos,AddCloudImageViewRecord} from '@/api/CloudFilmService'
    import { GetFileServiceUrl,GetGoBackUrlParms } from '../../utils/cacheUtils'
    import { DecryptAES } from '../../utils/stringUtils'

    export default {
        data() {
            return {
                filmList: null
            };
        },
        methods: {
            //查看报告图片
            handerImagePreview(index) {
                ImagePreview({
                    images: this.filmList,
                    closeable: true,
                    maxZoom:10,
                    startPosition:index
                });
            },
            handelLeftMenuFunc(){
                 this.$router.push({path:'/reportView?'+GetGoBackUrlParms()})
            },
        },
        activated() {
            this.filmList = []
            GetPatientReportImageInfos({ patientreportID: this.$route.query.reportInfoID }).then(async resp => {
                if (resp && resp.Success && resp.Result) {
                    let FilmFileList = resp.Result.find((c) => c.Category === 1)
                    if (FilmFileList && FilmFileList.Images && FilmFileList.Images.length > 0) {
                        AddCloudImageViewRecord({
                        CloudImagePatientID: DecryptAES(this.$route.query.CloudImagePatientID),
                        IDs: FilmFileList.ExaminationImageIDs,
                        }).then()
                    }
                    const fileServiceUrl = await GetFileServiceUrl()
                    let fimeImages = resp.Result.filter(c => c.Category === 1).map(c => c.Images)
                    fimeImages=fimeImages[0]
                    if (fimeImages && fimeImages.length > 0) {
                        fimeImages.forEach(item => {
                            this.filmList.push(fileServiceUrl + item.ImageRelaFileName)
                        });
                    } else {
                        this.$notify({ type: 'warning', message: '没有查询到该检查的胶片！' })
                    }
                }
            })
        },
    };
</script>

<style scoped>
    /**rest**/
    body,
    ul,
    li,
    section,
    div {
        padding: 0;
        margin: 0;
    }

    body {
        font-family: Arial, Roboto, "Droid Sans", "Hiragino Sans GB", STXihei,
            "sans-serif";
        width: 100%;
        -webkit-user-select: none;
        -webkit-touch-callout: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-text-size-adjust: none;
    }

    ul,
    li {
        list-style: none;
    }

    img {
        border: 0;
    }

    .list {
        width: 100%;
        height: 94vh;
        padding: 10px 0;
        background-color: red;
    }

    .list li {
        display: block;
        height: 100%;
        margin-bottom: 10px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 -1px 2px rgba(0, 0, 0, 0.1);
    }

    .list li img {
        width: 100%;
        height: auto;
    }

    /*弹框样式*/
    .imgzoom_pack {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.7);
        display: none;
    }

    .imgzoom_pack .imgzoom_x {
        color: #fff;
        height: 30px;
        width: 30px;
        line-height: 30px;
        background: #000;
        text-align: center;
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 10;
        cursor: pointer;
    }

    .imgzoom_pack .imgzoom_img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
    }

    .imgzoom_pack .imgzoom_img img {
        width: 100%;
        position: absolute;
        top: 50%;
    }

    .images {
        height: 96vh;
        width: 100%;
        background-color: red;
    }

    img.double-border {
        border: 1px solid #ddd;

        padding: 1px;

        background: #fff;
    }
</style>